export enum EmployeeLogTypes {
  Shift = 1,
  SickLeave = 2,
  FreeDay = 3
}
